/**
 * Hit endpoint
 * Returning either replacement form HTML to display errors
 * or JSON with redirect url
 */

import debug from "debug";

import plugin from '../../lib/plugin';

const MODULE_NAME = 'app.core/modules/fetch-field-detail';
const log = debug(MODULE_NAME);

const ELEMENT_SELECTOR = '[data-fetch-field-detail]';
const PROGRESS_CLASS = 'has-progress';



class FetchFieldDetail {
    constructor(element, options) {
        this.element = element;
        this.options = options;
		this.$element = $(element);

		this.$progressIndicator = $(this.options.progressSelector);
		this.$outputPanel = $(this.options.outputSelector);
		this.$failPanel = $(this.options.failSelector);
		this.$retryButton = $(this.options.retrySelector);

        log('FetchFieldDetail', element, options);
        this.watch();
    }

    onChange(event) {
        this.$progressIndicator
            .addClass(PROGRESS_CLASS);

		const data = {};
		data[this.options.key] = this.$element.val();

        $.get({
            url: this.options.endpoint,
            data: data
        })
            .done(this.handleResponse.bind(this))
            .error(this.handleError.bind(this))
			.always(this.onHaltProgress.bind(this));
	}

	handleResponse(result, status, xhr) {
		const contentType = xhr.getResponseHeader('content-type') || '';

		this.$failPanel.attr('hidden','hidden');
		this.$outputPanel.removeAttr('hidden');

		if (contentType.indexOf('json') > -1) {
			log('Error', result);
		} else {
			this.$outputPanel.html($(result));
		}
	}

	handleError(result) {
		log('error', result);
		this.$failPanel.removeAttr('hidden');
		this.$outputPanel.attr('hidden','hidden');
	}

	retry() {
		this.$element.trigger('change.fetchfielddetail');
	}

	onHaltProgress() {
		this.$progressIndicator
			.removeClass(PROGRESS_CLASS);
	}

    watch() {
		this.$element.on('change.fetchfielddetail', this.onChange.bind(this));
		this.$retryButton.on('click.fetchfielddetail', this.retry.bind(this));
    }

    unwatch() {
        this.$element.off('.fetchfielddetail');
        this.$retryButton.off('.fetchfielddetail');
    }
}

FetchFieldDetail.DEFAULTS = {

};

plugin('fetchFieldDetail', FetchFieldDetail);

export function exec() {
    $(document).ready(() => {
        log('binding');
        $(ELEMENT_SELECTOR).fetchFieldDetail();
        log('bound');
    });
}





// WEBPACK FOOTER //
// ./client/src/core/modules/fetch-field-detail/index.js